import React, { useState } from "react";
import Button from "../../ButtonUI";
import TimePicker from "react-time-picker";

import makeToast from "../../Snackbar";
import { getAgendaConfig, setAgendaConfiguration } from "../../../api/medecin";
import { useAtom } from "jotai";
import { userAtom } from "../../../state/auth";
import Tooltip from "../../toolTip";

interface IRes {
  doctor_id: string;
  agendaConfig: any;
}
const DAYS_IN_WEEK = [
  {
    day: "Lundi",
    active: false,
    timeRange: { start: "09:00", end: "18:00" },
    nbreqMax: "1",
  },
  {
    day: "Mardi",
    active: false,
    timeRange: { start: "09:00", end: "18:00" },
    nbreqMax: "1",
  },
  {
    day: "Mercredi",
    active: false,
    timeRange: { start: "09:00", end: "18:00" },
    nbreqMax: "1",
  },
  {
    day: "Jeudi",
    active: false,
    timeRange: { start: "09:00", end: "18:00" },
    nbreqMax: "1",
  },
  {
    day: "Vendredi",
    active: false,
    timeRange: { start: "09:00", end: "18:00" },
    nbreqMax: "1",
  },
  {
    day: "Samedi",
    active: false,
    timeRange: { start: "09:00", end: "18:00" },
    nbreqMax: "1",
  },
  {
    day: "Dimanche",
    active: false,
    timeRange: { start: "09:00", end: "18:00" },
    nbreqMax: "1",
  },
];

interface Props {
  closeModal: any;
  dataToMap: any[];
}

const Presentiel = (props: Props) => {
  const { closeModal, dataToMap } = props;
  const [loadingBtn, setLoadingBtn] = React.useState<boolean>(false);
  const [temp, setTemp] = useState(dataToMap);
  const [data] = useState<IRes>();
  const [user] = useAtom(userAtom);

  const [selectedInput, setSelectedInput] = useState("");
  // const [officeWorkingHours, setOfficeWorkingHours] = useState<{
  //   start: any;
  //   end: any;
  // }>({
  //   start: "09:00",
  //   end: "18:00",
  // });
  const [start, setStart] = useState("09:00");
  const [end, setEnd] = useState("18:00");

  const [nbrReqMax, setNbrReqMax] = useState("");

  const dataToPayload = () => {
    const payload = {
      doctor_id: user?._id,
      agendaConfig: temp
        .filter((e) => e.active)
        .map((e) => {
          return {
            day: e.day,
            rnageOfTime: e.timeRange,
            nbrReqMax: e.nbreqMax,
          };
        }),
      nbrMaxReq: 7,
    };

    return payload;
  };

  const updateTemp = async (t) => {
    let cTemp = [...temp];
    const newTemp = cTemp.map((e) => {
      if (t.day === e.day) {
        e.active = !e.active;
        //e.timeRange = officeWorkingHours;
        e.nbreqMax = "1";
      }

      return e;
    });
    return newTemp;
  };
  const restTemp = async (active: boolean) => {
    let cTemp = [...temp];
    const newTemp = cTemp.map((e) => {
      e.active = active;
      //e.timeRange = officeWorkingHours;
      e.nbreqMax = nbrReqMax;
      return e;
    });

    return newTemp;
  };

  const submitTimeSlots = async () => {
    try {
      setLoadingBtn(true);

      const res = await setAgendaConfiguration(dataToPayload());

      setLoadingBtn(false);
      closeModal();
    } catch (error) {
      setLoadingBtn(false);
      makeToast(
        "error",
        "Quelque chose s'est mal passé. Veuillez réessayer plus tard"
      );
      console.error(error);
    }
  };

  function handleChange(e, el) {
    console.log("element", el);
    const nbreqMax = e.target.value;
    setTemp(
      temp.map((elm) => (elm.day === el.day ? { ...elm, nbreqMax } : elm))
    );
  }

  function handleStartTimerChange(start, t) {
    console.log("start", start)
    console.log("t",t)
    setTemp(
      temp.map((elm) =>
        elm.day === t.day
          ? { ...elm, timeRange: { start, end: elm.timeRange.end } }
          : elm
      )
    );
  }

  function handleEndTimerChange(end, t) {
    setTemp(
      temp.map((elm) =>
        elm.day === t.day
          ? { ...elm, timeRange: { start: elm.timeRange.start, end } }
          : elm
      )
    );
  }

  return (
    <>
      <div>
        <div className="ml-40">
          <div className="workingDays flex flex-wrap gap-4">
            {temp.map((t, index) => {
              return (
                <div key={index} className="flex-parent-element flex items-center w-full">
                  <div
                    className="flex-child-element"
                    style={{
                      minWidth: "100px",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    onClick={async () => {
                      setTemp(await updateTemp(t));
                    }}
                    aria-checked={t.active}
                  >
                    <p>{t.day}</p>
                  </div>{" "}
                  <input
                    className="flex-child-element"
                    style={{
                      height: "44px",
                      borderRadius: "5px",
                      border: "1px solid rgba(166, 169, 200, 0.22)",
                      width: "63px",
                      textAlign: "center",
                      color: "rgb(69, 101, 246)",
                      outline: "none",
                    }}
                    type="number"
                    placeholder="1"
                    disabled={!t.active}
                    value={t.nbreqMax}
                    onChange={(e) => handleChange(e, t)}
                  />{" "}
                  <p
                    style={{
                      marginTop: "0px",
                      marginRight: "10px",
                      marginLeft: "27px",
                      fontSize: "16px",
                    }}
                  >
                    du:{" "}
                  </p>
                  <div className="w-[140px] rounded-md border border-gray-200 p-2">
                    <style>{`
                      .react-time-picker, .react-time-picker__wrapper, .react-time-picker__inputGroup {
                        display: flex !important;
                        flex-direction: row !important;
                        align-items: center !important;
                        justify-content: center !important;
                        border: none !important;
                        width: 100% !important;
                      }
                      .react-time-picker__inputGroup input {
                        background: transparent !important;
                        outline: none !important;
                        text-align: center !important;
                      }
                    `}</style>
                    <TimePicker
                      onChange={(start) => handleStartTimerChange(start, t)}
                      format="HH:mm"
                      value={t.timeRange.start}
                      disabled={!t.active}
                      clearIcon={null}
                      disableClock={true}
                      onClockOpen={() => {}}
                    />
                  </div>
                  <p
                    className="px-3"
                    style={{
                      marginTop: "0px",
                      fontSize: "16px",
                    }}
                  >
                    à:{" "}
                  </p>
                  <div className="w-[140px] rounded-md border border-gray-200 p-2">
                    <TimePicker
                      onChange={(end) => handleEndTimerChange(end, t)}
                      format="HH:mm"
                      value={t.timeRange.end}
                      disabled={!t.active}
                      clearIcon={null}
                      disableClock={true}
                      onClockOpen={() => {}}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div></div>
        <div className="flexCenterBtn my-10">
          <Button
            status="secondary"
            width="170px"
            height="50px"
            onClick={async () => {
              setTemp(await restTemp(false));
            }}
          >
            Réinitialiser
          </Button>

          <Button
            status="primary"
            width="170px"
            height="50px"
            onClick={submitTimeSlots}
            disabled={loadingBtn}
          >
            <div>
              {loadingBtn && (
                <div className="absolute h-full w-full flexCenter">
                  <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-purple-500"></div>
                </div>
              )}
              Enregistrer
            </div>
          </Button>
        </div>
      </div>
    </>
  );
};

export default Presentiel;
